import { styled } from 'styled-components';

export const JsonBlock = styled.pre`
  margin: 0;
  padding: 1rem;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: #111827;
  color: #f9fafb;
  border-radius: 0.5rem;
  overflow: auto;
`;
